import genererContactObject from '@/services/tiers/genererContact';
import set from 'lodash/set';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import booleanConverter from '@/services/import/General/booleanConverter';

function getParametreIdFromStore(nom, value) {
  return store.getters['parametres/parametre'](PARAMETRES_KEYS[nom])?.find((param) => {
    return param.libelle.toLowerCase().trim() === value?.toLowerCase()?.trim();
  })?.id ?? null;
}

export function fillContactWithData(contact, ligne, tiers) {
  const errors = [];
  const banColumnAuto = ['civilite'];
  const boolColumn = ['archive', 'adresseContactDifferente'];
  const keys = Object.keys(ligne);
  // fait tout les columns facile
  for (let i = 0; i < keys.length; i += 1) {
    if (!banColumnAuto.includes(keys[i])) {
      const val = boolColumn.includes(keys[i]) ? booleanConverter(ligne[keys[i]]) : ligne[keys[i]];
      set(contact, keys[i], val);
    }
  }
  const tier = tiers.find(t => t.referenceExterne === ligne.tiersId);
  contact.tiersId = tier.id;
  if (!contact.adresseContactDifferente) contact.adresse = tier.adressePostale;
  contact.civiliteId = getParametreIdFromStore('civilite', ligne.civilite);
  contact.typesContactIds = contact.typesContactIds
    ? contact.typesContactIds.map(tc => getParametreIdFromStore('typeContact', tc))
    : [];
  contact.utilisateur = null;
  if (errors.length > 0) throw errors;
  return contact;
}

export default function genererContact(ligne, tiers) {
  const contact = genererContactObject();
  return fillContactWithData(contact, ligne, tiers);
}
